export default function BtnEditSvg ({customFill}) {
    var newFill = "#9DB4FF";
    if (customFill) {
        newFill = customFill;
    }
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M0 18.9993V24H5.00069L19.7561 9.24462L14.7554 4.24392L0 18.9993ZM23.6099 5.39075C24.13 4.87068 24.13 4.02389 23.6099 3.50382L20.4962 0.390054C19.9761 -0.130018 19.1293 -0.130018 18.6093 0.390054L16.1689 2.83039L21.1696 7.83109L23.6099 5.39075Z" 
            fill={newFill}/>
        </svg>
    )
}